// removed by extract-text-webpack-plugin
module.exports = {"uso":"_24pIG962OS1p6cBjsY3xQP","left":"_14-amor7MtG10BGB4aCmQT","right":"_2zyvVIrgo_zGYefWY0j6gq","caption":"T4XwrpbhK7M6vwFJJJLpj","wrap":"cwXfPnTrv36Q-HXHxlTh7","triangle-left":"_3JD2uBgT1eR-0PkKbqSR8V","triangle-right":"_2GoFS_M12s7mVEudI3pCSa","avar":"_2hdYx_hUeehdcYGateq1Xk","blink":"_3sl216mxlxMOPlIGDXty4f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Uso/style.css
// module id = 289
// module chunks = 0